import React from 'react';
import classNames from 'classnames';
import './index.scss';

export default function CtLink(props) {
  const { to, text, type, className } = props;
  const cls = classNames(className, 'material-link', {
    'material-link--arrow': type === 'arrow',
    'material-link--white-hole': type === 'hole',
  });
  return (
    <a href={to} className={cls}>
      <span className="material-link__inner">{text}</span>
    </a>
  );
}
